import { PageData, PartialData } from '../../types';

export const isPageData = (data?: unknown): data is PageData => {
  return !!data && !!(data as PageData).actions;
};

export const isPartialData = (data?: unknown): data is PartialData => {
  return !!data && !!(data as PartialData).actions;
};
